import type { ComponentType } from 'react';
import React from 'react';
import type { MessageDescriptor } from 'react-intl-next';
import { FormattedMessage } from 'react-intl-next';

import { token } from '@atlaskit/tokens';
import Image from '@atlaskit/image';
import { Box, Inline, Stack, xcss } from '@atlaskit/primitives';
import type { NewCoreIconProps } from '@atlaskit/icon';

import { fg } from '@confluence/feature-gating';
import { Link } from '@confluence/route-manager';

const iconBoxStyle = xcss({
	backgroundColor: 'color.background.information',
	height: '40px',
	width: '40px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	borderRadius: 'border.radius.100',
});

const imgStyle = xcss({
	width: '40px',
	paddingTop: 'space.050',
});

const titleTextStyle = xcss({
	font: token('font.body'),
	fontWeight: token('font.weight.bold'),
});

const bodyTextStyle = xcss({
	font: token('font.body'),
});

const linkTextStyle = xcss({
	color: 'color.link',
	font: token('font.body'),
});

export type ListItemProps = {
	label?: string;
	bodyText: MessageDescriptor;
	darkImg: string;
	img: string;
	icon: ComponentType<NewCoreIconProps>;
	title: MessageDescriptor;
	linkText: MessageDescriptor;
	link: string;
	onLinkClick?: () => void;
};

export const ListItem = ({
	label,
	img,
	darkImg,
	icon,
	title,
	bodyText,
	linkText,
	link,
	onLinkClick,
}: ListItemProps) => {
	const Icon = icon;

	return (
		<Inline space="space.200">
			<Box xcss={imgStyle}>
				{fg('platform-visual-refresh-icons') ? (
					<Box xcss={iconBoxStyle}>
						<Icon label="" color={token('color.icon.information')} />
					</Box>
				) : (
					<Image src={img} srcDark={darkImg} alt={`${label} icon`} css={{ minWidth: '40px' }} />
				)}
			</Box>
			<Stack space="space.050">
				<Box xcss={titleTextStyle}>
					<FormattedMessage {...title} />
				</Box>
				<Box xcss={bodyTextStyle}>
					<FormattedMessage {...bodyText} />
				</Box>
				<Box xcss={linkTextStyle}>
					<Link target="_blank" href={link} onClick={onLinkClick}>
						<FormattedMessage {...linkText} />
					</Link>
				</Box>
			</Stack>
		</Inline>
	);
};
